import { store } from '~/store';
import React from 'react';
import { ReactQueryDevtools } from 'react-query/devtools';
import { Provider } from 'react-redux';
import { AuthProvider } from '~/providers/AuthProvider';
import { AppRoutes } from './AppRoutes';
import { AppToastsProvider } from '~/providers/AppToastsProvider';
import { QueryClientProviderWithErrorReporting } from '~/providers/QueryClientProviderWithErrorReporting';
import { RollbarErrorReporting } from '~/providers/RollbarErrorReporting';
// import CssBaseline from '@mui/material/CssBaseline';
// import { StyledEngineProvider } from '@mui/material/styles';
import { ThemeProvider, createTheme } from '@mui/material/styles';
const THEME = createTheme({
    typography: {
        'fontFamily': '"Barlow"',
    }
});
export const App = () => {
    return (React.createElement(RollbarErrorReporting, null,
        React.createElement(QueryClientProviderWithErrorReporting, null,
            React.createElement(AuthProvider, null,
                React.createElement(ThemeProvider, { theme: THEME },
                    React.createElement(Provider, { store: store },
                        React.createElement(AppRoutes, null))),
                React.createElement(AppToastsProvider, null)),
            React.createElement(ReactQueryDevtools, { initialIsOpen: false }))));
};
